import { useI18n } from '../../../../i18n/i18n'
import './brands-strip.scss'

// Placeholder: marcas fictícias do ramo alimentar. Trocar por clientes reais depois.
const marcas = [
  { nome: 'Cantina Bella', emoji: '🍝' },
  { nome: 'Padaria Grão', emoji: '🥐' },
  { nome: 'Café Aurora', emoji: '☕' },
  { nome: 'Hotel Miramar', emoji: '🏨' },
  { nome: 'Pousada Maré Alta', emoji: '🌴' },
  { nome: 'Bar do Porto', emoji: '🍸' },
]

export function BrandsStrip() {
  const { t } = useI18n()
  return (
    <section className="brands-strip">
      <div className="brands-strip__head">
        <span className="eyebrow">{t('brands.subtitle')}</span>
        <h2 className="section-heading">{t('brands.title')}</h2>
      </div>
      <div className="brands-strip__row">
        {marcas.map((m) => (
          <div className="brands-strip__brand" key={m.nome}>
            <span className="brands-strip__emoji" aria-hidden>{m.emoji}</span>
            <span className="brands-strip__nome">{m.nome}</span>
          </div>
        ))}
      </div>
    </section>
  )
}
